const SplashScreen = {
  hide: () => (document.getElementById('splashscreen').style.display = 'none'),
};

export default SplashScreen;
